import i18n from '@/i18n';
import {PartOfTheDay} from '@/services/graphqlHooks';

const partOfTheDay = {
  [PartOfTheDay.Morning]: i18n.t('Morning'),
  [PartOfTheDay.Afternoon]: i18n.t('Afternoon'),
  [PartOfTheDay.Evening]: i18n.t('Evening'),
  [PartOfTheDay.Night]: i18n.t('Night'),
} as Record<PartOfTheDay, string>;

export default partOfTheDay;
